import React, { Fragment } from "react";
import PropTypes from "prop-types";

const VipJumbotron = ({ game_id, products, gift }) => {
  const slogan =
    game_id === "g66naxx2tw" || game_id === "G115"? (
      <h5 className="display-5">
        <span role="img" aria-label="fire">
          🔥🔥
        </span>
        千呼萬喚的儲值方案登場了!!
        <span role="img" aria-label="fire">
          🔥🔥
        </span>
      </h5>
    ) : game_id === "MA96" ? (
      <h5 className="display-5">
        <span role="img" aria-label="prince princess">
          🤴👸
        </span>
        親愛的冒險家，千呼萬喚的儲值方案登場了!!
        <span role="img" aria-label="prince princess">
          🤴👸
        </span>
      </h5>
    ) : (
      <h5 className="display-5">
        <span role="img" aria-label="magnifier">
          🔎 🔎
        </span>
        各位親愛的偵探們照過來
        <span role="img" aria-label="magnifier">
          🔎 🔎
        </span>
      </h5>
    );

  const banner =
    game_id === "g66naxx2tw" ? (
      <img
        src="/p/image/support_help/g66_wire_report_banner.jpg"
        className="rounded img-fluid m-auto"
        alt="千呼萬喚的儲值方案登場了!!"
      ></img>
    ) : game_id === "G115" ? (
      <img
        src="/p/image/support_help/g115_wire_report_banner.png"
        className="rounded img-fluid m-auto"
        alt="千呼萬喚的儲值方案登場了!!"
      ></img>
    ) : game_id === "MA96" ? (
      <img
        src="/p/image/support_help/ma96_wire_report_banner.jpg"
        className="rounded img-fluid m-auto"
        alt="親愛的冒險家，千呼萬喚的儲值方案登場了!!"
      ></img>
    ) : (
      <img
        src="/p/image/support_help/h55_wire_report_banner.png"
        className="rounded img-fluid m-auto"
        alt="各位親愛的偵探們照過來!!"
      ></img>
    );

  const event_alert =
    game_id === "g66naxx2tw" ? gift && (
      <div className="alert alert-primary" role="alert">
        <h5 className="alert-heading"> 限時滿額禮：</h5>
        單筆購買滿NTD 15,000元以上， <br />
        {gift.items}
        <br />
        購買滿NTD 30,000元，即贈送兩包滿額禮，以此類推！
        <br />
        滿額禮僅計算<strong>單筆消費</strong>，無法累積計算或合併計算。
      </div>
    ) : game_id === "MA96" ? (
      <div className="alert alert-primary" role="alert">
        現在全面試營運中
      </div>
    ) : null;

  const comma = /\B(?=(\d{3})+$)/g;  
  const products_info = (
    <div>
      <h3 className="mt-2">方案如下 ：</h3>
      <ul>
        {products.map((prod) => (
          <li key={`prod_${prod.product_id}`}>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD.{prod.price.toString().replace(comma, ',')}，共可獲得 {prod.gold.toString().replace(comma, ',')}{" "}
            {game_id === "g66naxx2tw" ? "信用點" : game_id === "G115" ? "有償海藍石" : game_id === "MA96" ? "鑽石" : "回聲"}
            {(game_id === "MA96") ? (
              <span>{` + ${prod.free_golds.toString().replace(comma, ',')} 綁鑽`}</span>              
            ) : (game_id === "G115") ? (
              <span>{` + ${prod.free_golds.toString().replace(comma, ',')} 無償海藍石`}</span>              
            ) : null}
            。
            {(game_id === "g66naxx2tw" && prod.price >= 15000) ? (
              <span role="img" aria-label="gift">
                🎁
              </span>
            ) : null}
          </li>
        ))}
      </ul>
      <br />
    </div>
  );

  const special_note =
    game_id === "g66naxx2tw" ? (
      <strong className="text-danger">
        <span role="img" aria-label="loudspeaker">
          📢
        </span>
        電台方案僅適用【台灣龍邑版本】，用戶需使用雙平台商店所下載的台灣龍邑版本。如非使用台灣龍邑版本，請先更換版本後再行匯款填單。
        <br />
        <span role="img" aria-label="loudspeaker">
          📢
        </span>
        若您欲購買未滿3000元的品項，歡迎使用
        <a target="blank" href="https://www.lifeafterpay.com/">
          <img
            width="60"
            alt="MyCard logo"
            src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
          />
        </a>
        進行儲值喔!
        <br />
      </strong>
    ) : game_id === "G115" ? (
      <strong className="text-danger">
        <span role="img" aria-label="loudspeaker">
          📢
        </span>
        若您欲購買未滿5000元的品項，歡迎使用
        <a target="blank" href="https://pay.longeplay.com.tw/mysticabyss/topup">
          <img
            width="60"
            alt="MyCard logo"
            src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
          />
        </a>
        進行儲值喔!
        <br />
        <span role="img" aria-label="loudspeaker">
          📢
        </span>
        港澳及非台灣之海外地區目前尚未開放儲值方案購買，後續將盡快提供服務。
        <br />
      </strong>
    ) : game_id === "MA96" ? (
      <strong className="text-danger">
        <span role="img" aria-label="loudspeaker">
          📢
        </span>
        方案現僅適用【龍邑台港澳版本】，請確認有可匯款至台灣銀行的帳戶，再進行匯款填單。
        <br />
        <span role="img" aria-label="loudspeaker">
          📢
        </span>
        若您欲購買未滿5000元的品項，歡迎使用
        <a target="blank" href="https://www.neverafter-pay.tw/">
          <img
            width="60"
            alt="MyCard logo"
            src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
          />
        </a>
        進行儲值喔!
        <br />
      </strong>
    ) : (
      <strong className="text-danger">
        <span role="img" aria-label="loudspeaker">
          📢
        </span>
        僅提供龍邑亞洲服角色購買。
        <br />
      </strong>
    );
  // ? 'NTD.3,000，信用點 6480 贈 1788，共可獲得 8268 信用點。'
  // : '儲值NTD.3,000，共可獲得7200回聲。';
  const contact_nickname1 = game_id === "g66naxx2tw" || game_id === "G115" ? "小夥伴" : game_id === "MA96" ? "小精靈" : "小管家";

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6  col-sm-12  mt-3">{banner}</div>
        <div className="col-lg-3 mt-3"> </div>
      </div>
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6  col-sm-12 mt-3">
          <div className="jumbotron jumbotron-fluid">
            <div className="container">
              {slogan}
              <hr className="my-4" />
              {event_alert}
              {products_info}

              <p className="small">
                若您有購買意願的話，可直接以轉帳、匯款方式進行．
              </p>
              <p className="text-center">
                <span role="img" aria-label="sparkling stars">
                  ✨ ✨ ✨ ✨ 匯款資料 ✨ ✨ ✨ ✨
                </span>
                <br />
                第一銀行(007) <br />
                大坪林分行
                <br />
                帳號：222-10-038756
                <br />
                戶名：龍邑股份有限公司
                <br />
                <span role="img" aria-label="sparkling stars">
                  ✨ ✨ ✨ ✨ ✨ ✨ ✨ ✨ ✨ ✨ ✨ ✨
                </span>
              </p>
              <br />
              <br />
              <p className="small">
                匯款完畢後，還請您提供下方資訊，填妥後，這邊會請
                {contact_nickname1}儘快確認
                <br />
                <br />
                PS：
                <span className="text-danger">
                  <strong>匯款後</strong>
                </span>
                即無法進行退換貨的服務喔！
                <br />
                <br />
                {special_note}
                <strong className="text-danger">
                <span role="img" aria-label="loudspeaker">
                  📢
                </span>
                未滿18歲之購買者，將無法提供後續服務。
                  <br />
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

VipJumbotron.propTypes = { game_id: PropTypes.string.isRequired };

export default VipJumbotron;
